import dayjs from "dayjs";
import { PERIOD_MAP } from "components/CartModal/CartModal";
import { MM_SPACE_YYYY } from "constants/date";
import { Cart as CartT } from "store/apis/products";
import { ArrayElement } from "types/utils/ArrayElement";
import { formatDate } from "utils/formatDate";

type CartItem = ArrayElement<CartT["cart_items"]>;

// Single-line version of the cart "Period" column, or null when there's no period.
export const getCartItemPeriodLabel = ({
  product_details,
  subscription,
}: CartItem): string | null => {
  const { from_date, to_date, season } = product_details;

  if (from_date) {
    const start = dayjs(from_date).format(MM_SPACE_YYYY);
    const end = to_date ? ` - ${dayjs(to_date).format(MM_SPACE_YYYY)}` : "";
    return `Starts ${start}${end}`;
  }

  if (!subscription) return season ? `Season ${season}` : null;

  const billingCycle = subscription.billing_cycle;
  if (!billingCycle) return null;

  const validTill = dayjs().add(
    1,
    PERIOD_MAP[billingCycle] as dayjs.ManipulateType
  );

  return `${formatDate(dayjs())} - ${formatDate(validTill)}`;
};
